(function () {

  'use strict';

  if (window.TREK_COMPARE_GLOBAL_INITIALISED) {
    return;
  }

  window.TREK_COMPARE_GLOBAL_INITIALISED = true;

  var root = document.querySelector('[data-trek-compare-global]');

  if (!root) {
    return;
  }

  var bar = root.querySelector('[data-compare-bar]');
  var selectedProductsContainer = root.querySelector('[data-compare-products]');
  var drawer = root.querySelector('[data-compare-drawer]');
  var table = root.querySelector('[data-compare-table]');
  var emptyState = root.querySelector('[data-compare-empty]');
  var openButton = root.querySelector('[data-open-compare]');
  var clearButton = root.querySelector('[data-clear-compare]');
  var closeButtons = root.querySelectorAll('[data-close-compare]');

  if (!bar || !selectedProductsContainer || !drawer || !table || !emptyState) {
    return;
  }

  /* ==========================================================================
     DEBOUNCE

     theme.utils is provided by theme.min.js, which is deferred earlier in the
     document than this file, so it is normally available. The local fallback
     keeps the whole feature from throwing if that ever stops being true.
     ========================================================================== */

  var debounce =
    (
      window.theme &&
      theme.utils &&
      typeof theme.utils.debounce === 'function'
    )
      ? theme.utils.debounce
      : function (wait, callback) {
          var timer;

          return function () {
            var context = this;
            var args = arguments;

            clearTimeout(timer);

            timer = setTimeout(function () {
              callback.apply(context, args);
            }, wait);
          };
        };

  /* ==========================================================================
     BAR COLLAPSE / EXPAND
     ========================================================================== */

  var compareBarToggles = root.querySelectorAll('[data-compare-bar-toggle]');

  function setBarExpanded(expanded) {
    bar.classList.toggle('is-expanded', !!expanded);

    compareBarToggles.forEach(function (button) {
      button.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
      );
    });
  }

  if (compareBarToggles.length) {
    compareBarToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setBarExpanded(
          !bar.classList.contains('is-expanded')
        );
      });
    });
  }

  /* ==========================================================================
     COMPARISON SCROLL ARROWS
     ========================================================================== */

  var scrollLeftButton = root.querySelector('[data-compare-scroll-left]');
  var scrollRightButton = root.querySelector('[data-compare-scroll-right]');

  function updateCompareScrollArrows() {
    if (!selectedProductsContainer || !scrollLeftButton || !scrollRightButton) {
      return;
    }

    var scrollLeft = selectedProductsContainer.scrollLeft;

    var maxScroll =
      selectedProductsContainer.scrollWidth -
      selectedProductsContainer.clientWidth;

    var hasOverflow = maxScroll > 2;

    if (!hasOverflow) {
      scrollLeftButton.classList.remove('is-visible');
      scrollRightButton.classList.remove('is-visible');
      return;
    }

    if (scrollLeft > 2) {
      scrollLeftButton.classList.add('is-visible');
    } else {
      scrollLeftButton.classList.remove('is-visible');
    }

    if (scrollLeft < maxScroll - 2) {
      scrollRightButton.classList.add('is-visible');
    } else {
      scrollRightButton.classList.remove('is-visible');
    }
  }

  if (scrollLeftButton) {
    scrollLeftButton.addEventListener('click', function () {
      selectedProductsContainer.scrollBy({
        left: -150,
        behavior: 'smooth'
      });
    });
  }

  if (scrollRightButton) {
    scrollRightButton.addEventListener('click', function () {
      selectedProductsContainer.scrollBy({
        left: 150,
        behavior: 'smooth'
      });
    });
  }

  selectedProductsContainer.addEventListener(
    'scroll',
    updateCompareScrollArrows,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    debounce(150, updateCompareScrollArrows)
  );

  /* ==========================================================================
     COMPARISON CONFIGURATION
     ========================================================================== */

  var DEFAULT_COMPARE_CONFIG = [
    {
      id: 'default-product',
      type: 'product',
      show: true,
      name: 'Product'
    },
    {
      id: 'default-price',
      type: 'price',
      show: true,
      name: 'Price'
    },
    {
      id: 'default-pdp-tagline',
      type: 'pdp_tagline',
      show: true,
      name: 'PDP Tagline'
    },
    {
      id: 'default-description',
      type: 'description',
      show: true,
      name: 'Description'
    },
    {
      id: 'default-specifications',
      type: 'specifications',
      show: true,
      name: 'Specifications'
    },
    {
      id: 'default-technology',
      type: 'technology',
      show: true,
      name: 'Technology'
    }
  ];

  var storedConfig;

  function getCompareConfig() {
    if (
      Array.isArray(window.TREK_COMPARE_CONFIG) &&
      window.TREK_COMPARE_CONFIG.length
    ) {
      return window.TREK_COMPARE_CONFIG;
    }

    if (storedConfig === undefined) {
      storedConfig = null;

      try {
        var stored = localStorage.getItem('trekKitCompareConfig');

        if (stored) {
          var parsed = JSON.parse(stored);

          if (Array.isArray(parsed) && parsed.length) {
            storedConfig = parsed;
          }
        }
      } catch (error) {}

    }

    return storedConfig || DEFAULT_COMPARE_CONFIG;
  }

  function getFieldConfig(type) {
    var config = getCompareConfig();

    for (var i = 0; i < config.length; i++) {
      if (config[i] && config[i].type === type) {
        return config[i];
      }
    }

    return null;
  }

  function shouldShowField(type) {
    var field = getFieldConfig(type);

    if (!field) {
      return false;
    }

    return field.show !== false;
  }

  function getFieldName(type, fallback) {
    var field = getFieldConfig(type);

    if (
      field &&
      field.name !== undefined &&
      field.name !== null &&
      String(field.name).trim() !== ''
    ) {
      return String(field.name).trim();
    }

    return fallback;
  }

  /* ==========================================================================
     STORAGE
     ========================================================================== */

  var STORAGE_KEY = 'trekKitCompareProducts';

  var products = [];

  var compareHistoryActive = false;

  /*
   * GLOBAL options state.
   *
   * false = all option panels closed
   * true  = all option panels open
   *
   * This is intentionally NOT stored in localStorage.
   */

  var compareOptionsOpen = false;

  function loadProducts() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        products = [];
        return;
      }

      var parsed = JSON.parse(stored);

      if (Array.isArray(parsed)) {
        products = parsed.filter(function (item) {
          return item && item.id && item.handle;
        });
      } else {
        products = [];
      }
    } catch (error) {
      products = [];
    }
  }

  function saveProducts() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(products)
      );
    } catch (error) {

      /*
       * Almost always a quota error caused by the cached Shopify product
       * payloads. Retry with a slim record so the selection itself survives;
       * the variant data is re-fetched the next time the drawer opens.
       */

      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(
            products.map(function (product) {
              return {
                id: product.id,
                handle: product.handle,
                url: product.url,
                title: product.title,
                image: product.image,
                vendor: product.vendor
              };
            })
          )
        );
      } catch (fallbackError) {}
    }
  }

  /* ==========================================================================
     HELPERS
     ========================================================================== */

  function escapeHtml(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  var htmlParser;

  function stripHtml(value) {
    if (!value) {
      return '';
    }

    /*
     * A <template> parses into an inert document fragment: unlike a detached
     * <div>, it will not load images or fire inline handlers from merchant
     * authored metafield HTML.
     */

    if (!htmlParser) {
      htmlParser = document.createElement('template');
    }

    htmlParser.innerHTML = value;

    var text = htmlParser.content.textContent || '';

    htmlParser.innerHTML = '';

    return text;
  }

  function cleanText(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return stripHtml(String(value))
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatMoney(cents) {
    if (
      cents === null ||
      cents === undefined ||
      cents === ''
    ) {
      return '';
    }

    /*
     * Impulse exposes theme.Currency.formatMoney, not Shopify.formatMoney.
     * Using it keeps compare prices identical to the grid, PDP and cart.
     */

    if (
      window.theme &&
      theme.Currency &&
      typeof theme.Currency.formatMoney === 'function'
    ) {
      try {
        return theme.Currency.formatMoney(
          cents,
          theme.settings && theme.settings.moneyFormat
        );
      } catch (error) {}
    }

    if (
      window.Shopify &&
      typeof Shopify.formatMoney === 'function'
    ) {
      try {
        return Shopify.formatMoney(
          cents,
          window.theme &&
            theme.settings &&
            theme.settings.moneyFormat
        );
      } catch (error) {}
    }

    var amount = Number(cents) / 100;

    return '₹' + amount.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function hasValue(value) {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      return value.trim() !== '';
    }

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === 'object') {
      return Object.keys(value).length > 0;
    }

    return true;
  }

  function productExists(productId) {
    return products.some(function (product) {
      return String(product.id) === String(productId);
    });
  }

  function getProductById(productId) {
    for (var i = 0; i < products.length; i++) {
      if (String(products[i].id) === String(productId)) {
        return products[i];
      }
    }

    return null;
  }

  /* ==========================================================================
     CURRENT PAGE PRODUCT DATA
     ========================================================================== */

  var dataElement = document.getElementById('TrekCompareData');

  function mergeProductData(element) {
    if (!element) {
      return;
    }

    try {
      var parsed = JSON.parse(element.textContent);
    } catch (error) {
      return;
    }

    window.TREK_COMPARE_PRODUCT_DATA =
      window.TREK_COMPARE_PRODUCT_DATA || {};

    Object.keys(parsed).forEach(function (handle) {
      window.TREK_COMPARE_PRODUCT_DATA[handle] =
        parsed[handle];
    });
  }

  mergeProductData(dataElement);

  if (dataElement) {

    /*
     * Filtering fires collection:reloaded on every interaction. Abort the
     * previous request so rapid filtering cannot leave several overlapping
     * section requests in flight (and cannot apply them out of order).
     */

    var compareDataController = null;

    document.addEventListener(
      'collection:reloaded',
      function () {
        var params =
          new URLSearchParams(window.location.search);

        params.set(
          'section_id',
          dataElement.getAttribute('data-section-id')
        );

        var url =
          window.location.pathname +
          '?' +
          params.toString();

        if (compareDataController) {
          compareDataController.abort();
        }

        compareDataController =
          typeof AbortController !== 'undefined'
            ? new AbortController()
            : null;

        fetch(
          url,
          compareDataController
            ? { signal: compareDataController.signal }
            : undefined
        )
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            mergeProductData(
              new DOMParser()
                .parseFromString(html, 'text/html')
                .getElementById('TrekCompareData')
            );
          })
          .catch(function () {});
      }
    );
  }

  function getPageProductData(handle) {
    if (
      !handle ||
      !window.TREK_COMPARE_PRODUCT_DATA
    ) {
      return null;
    }

    return (
      window.TREK_COMPARE_PRODUCT_DATA[handle] ||
      null
    );
  }

  /* ==========================================================================
     PRODUCT FROM CHECKBOX
     ========================================================================== */

  function getProductFromCheckbox(checkbox) {
    if (!checkbox) {
      return null;
    }

    var handle =
      checkbox.getAttribute('data-product-handle');

    var pageData =
      getPageProductData(handle);

    var product = {
      id: checkbox.getAttribute('data-product-id'),
      handle: handle,
      url: checkbox.getAttribute('data-product-url'),
      title: checkbox.getAttribute('data-product-title'),
      image: checkbox.getAttribute('data-product-image'),
      vendor: checkbox.getAttribute('data-product-vendor'),
      metafields: pageData || null,
      data: pageData || null,
      shopifyProduct:
        pageData &&
        Array.isArray(pageData.variants)
          ? pageData
          : null,
      dataLoaded: !!pageData
    };

    if (pageData) {
      product.id =
        pageData.id || product.id;

      product.url =
        pageData.url || product.url;

      product.title =
        pageData.title || product.title;

      product.image =
        pageData.image || product.image;

      product.vendor =
        pageData.vendor || product.vendor;

      product.metafields = pageData;
      product.data = pageData;

      if (Array.isArray(pageData.variants)) {
        product.shopifyProduct = pageData;
      }

      product.dataLoaded = true;
    }

    return product;
  }

  /* ==========================================================================
     FETCH PRODUCT DATA
     ========================================================================== */

  function fetchProductData(product) {
    if (!product || !product.handle) {
      return Promise.resolve(product);
    }

    var pageData =
      getPageProductData(product.handle);

    if (pageData) {
      product.metafields = pageData;
      product.data = pageData;

      if (Array.isArray(pageData.variants)) {
        product.shopifyProduct = pageData;
      }

      product.dataLoaded = true;
    }

    if (
      product.shopifyProduct &&
      Array.isArray(product.shopifyProduct.variants)
    ) {
      return Promise.resolve(product);
    }

    return fetch(
      '/products/' +
      encodeURIComponent(product.handle) +
      '.js'
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product request failed');
        }

        return response.json();
      })
      .then(function (data) {
        product.shopifyProduct = data;

        if (!product.metafields) {
          product.data = data;
        }

        if (!product.title && data.title) {
          product.title = data.title;
        }

        if (!product.url && data.url) {
          product.url = data.url;
        }

        if (
          !product.image &&
          data.featured_image
        ) {
          product.image = data.featured_image;
        }

        if (!product.vendor && data.vendor) {
          product.vendor = data.vendor;
        }

        product.dataLoaded = true;

        return product;
      })
      .catch(function () {
        product.dataLoaded = true;
        return product;
      });
  }

  /* ==========================================================================
     DATA GETTERS
     ========================================================================== */

  function getDescription(product) {
    if (
      product &&
      product.metafields &&
      product.metafields.description
    ) {
      return product.metafields.description;
    }

    if (
      product &&
      product.data &&
      product.data.description
    ) {
      return product.data.description;
    }

    return '';
  }

  function getPrice(product) {
    if (
      product &&
      product.metafields &&
      product.metafields.price !== undefined
    ) {
      return formatMoney(product.metafields.price);
    }

    if (
      product &&
      product.data &&
      product.data.price !== undefined
    ) {
      return formatMoney(product.data.price);
    }

    return '';
  }

  function getPdpTagline(product) {
    if (!product || !product.metafields) {
      return '';
    }

    var value =
      product.metafields.pdp_tagline;

    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }

    return cleanText(value);
  }

  function getTableTest2(product) {
    if (!product || !product.metafields) {
      return null;
    }

    var value =
      product.metafields.table_test_2;

    if (
      value === null ||
      value === undefined
    ) {
      return null;
    }

    if (typeof value === 'object') {
      return value;
    }

    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function getTechnologies(product) {
    if (!product || !product.metafields) {
      return [];
    }

    var technologies =
      product.metafields.technologies;

    if (typeof technologies === 'string') {
      try {
        technologies = JSON.parse(technologies);
      } catch (error) {
        technologies = [];
      }
    }

    if (!Array.isArray(technologies)) {
      return [];
    }

    return technologies.filter(function (technology) {
      return (
        technology &&
        (
          technology.name ||
          technology.icon ||
          technology.description
        )
      );
    });
  }

  function formatLabel(value) {
    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }

    return String(value)
      .replace(/[_-]+/g, ' ')
      .replace(
        /\b\w/g,
        function (letter) {
          return letter.toUpperCase();
        }
      )
      .trim();
  }

  function formatLinkedText(value) {
    var pattern =
      /<a\b[^>]*href\s*=\s*["']([^"']*)["'][^>]*>([\s\S]*?)<\/a>/gi;

    var result = '';
    var lastIndex = 0;
    var match;

    while (
      (match = pattern.exec(value)) !== null
    ) {
      result += escapeHtml(
        value.slice(lastIndex, match.index)
      );

      var url =
        match[1].trim();

      var text =
        cleanText(match[2]) ||
        url;

      result +=
        /^(https?:\/\/|\/)/i.test(url)
          ? '<a href="' +
            escapeHtml(url) +
            '" target="_blank" rel="noopener">' +
            escapeHtml(text) +
            '</a>'
          : escapeHtml(text);

      lastIndex =
        pattern.lastIndex;
    }

    return (
      result +
      escapeHtml(
        value.slice(lastIndex)
      )
    );
  }

  function formatGenericValue(value) {
    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }

    if (Array.isArray(value)) {
      return value
        .map(function (item) {
          return formatGenericValue(item);
        })
        .filter(function (item) {
          return item !== '';
        })
        .join(', ');
    }

    if (typeof value === 'object') {
      return Object.keys(value)
        .map(function (key) {
          return (
            escapeHtml(
              formatLabel(key)
            ) +
            ': ' +
            formatGenericValue(
              value[key]
            )
          );
        })
        .join('<br>');
    }

    return formatLinkedText(
      String(value)
    );
  }

  /* ==========================================================================
     TECHNOLOGIES
     ========================================================================== */

  function formatTechnologies(technologies) {
    if (
      !Array.isArray(technologies) ||
      !technologies.length
    ) {
      return '';
    }

    var html =
      '<div class="trek-compare-technologies">';

    technologies.forEach(function (technology) {
      var name =
        cleanText(technology.name);

      var description =
        cleanText(technology.description);

      if (!name && !description) {
        return;
      }

      html +=
        '<div class="trek-compare-technology">' +
          '<div class="trek-compare-technology__content">';

      if (name) {
        html +=
          '<div class="trek-compare-technology__name">' +
            escapeHtml(name) +
          '</div>';
      }

      if (description) {
        html +=
          '<div class="trek-compare-technology__description">' +
            escapeHtml(description) +
          '</div>';
      }

      html +=
          '</div>' +
        '</div>';
    });

    html +=
      '</div>';

    return html;
  }

  /* ==========================================================================
     DESCRIPTION
     ========================================================================== */

  function formatDescription(value) {
    if (!hasValue(value)) {
      return '';
    }

    var text =
      stripHtml(String(value));

    text = text
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n');

    var lines =
      text
        .split('\n')
        .map(function (line) {
          return line.trim();
        })
        .filter(function (line) {
          return line !== '';
        });

    if (!lines.length) {
      return '';
    }

    return (
      '<div class="trek-compare-description">' +
        escapeHtml(
          lines.join('\n')
        ).replace(/\n/g, '<br>') +
      '</div>'
    );
  }

  /* ==========================================================================
     TAGLINE
     ========================================================================== */

  function formatTagline(value) {
    if (!hasValue(value)) {
      return '';
    }

    return (
      '<div class="trek-compare-tagline">' +
        escapeHtml(cleanText(value)) +
      '</div>'
    );
  }

  /* ==========================================================================
     VARIANT HELPERS
     ========================================================================== */

  function getShopifyProduct(product) {
    if (!product) {
      return null;
    }

    if (
      product.shopifyProduct &&
      Array.isArray(product.shopifyProduct.variants)
    ) {
      return product.shopifyProduct;
    }

    if (
      product.data &&
      Array.isArray(product.data.variants)
    ) {
      return product.data;
    }

    return null;
  }

  function getProductVariants(product) {
    var data =
      getShopifyProduct(product);

    if (
      !data ||
      !Array.isArray(data.variants)
    ) {
      return [];
    }

    return data.variants;
  }

  /* --------------------------------------------------------------------------
     OPTION NAME NORMALISATION
     -------------------------------------------------------------------------- */

  function normaliseOptionName(option) {
    if (
      option === null ||
      option === undefined
    ) {
      return '';
    }

    if (typeof option === 'string') {
      return (
        option.charAt(0).toUpperCase() +
        option.slice(1).toLowerCase()
      );
    }

    if (typeof option === 'object') {
      if (option.name !== undefined) {
        return String(option.name);
      }

      if (option.label !== undefined) {
        return String(option.label);
      }

      if (option.title !== undefined) {
        return String(option.title);
      }

      return '';
    }

    return String(option);
  }

  function getProductOptionNames(product) {
    var data =
      getShopifyProduct(product);

    if (
      data &&
      Array.isArray(data.options) &&
      data.options.length
    ) {
      return data.options
        .map(function (option) {
          return normaliseOptionName(option);
        })
        .filter(function (name) {
          return name !== '';
        });
    }

    if (
      data &&
      data.options &&
      typeof data.options === 'object' &&
      !Array.isArray(data.options)
    ) {
      return Object.keys(data.options)
        .map(function (key) {
          var option =
            data.options[key];

          var name =
            normaliseOptionName(option);

          return name || key;
        })
        .filter(function (name) {
          return name !== '';
        });
    }

    var variants =
      getProductVariants(product);

    if (!variants.length) {
      return [];
    }

    var optionCount = 0;

    variants.forEach(function (variant) {
      for (var i = 1; i <= 3; i++) {
        if (
          variant['option' + i] !== undefined &&
          variant['option' + i] !== null &&
          variant['option' + i] !== ''
        ) {
          optionCount =
            Math.max(
              optionCount,
              i
            );
        }
      }
    });

    var names = [];

    for (var j = 0; j < optionCount; j++) {
      names.push(
        'Option ' + (j + 1)
      );
    }

    return names;
  }

  function getVariantOptionValue(
    variant,
    index
  ) {
    if (!variant) {
      return '';
    }

    var key =
      'option' + (index + 1);

    var value =
      variant[key];

    if (
      value &&
      typeof value === 'object'
    ) {
      if (value.name !== undefined) {
        return String(value.name);
      }

      if (value.value !== undefined) {
        return String(value.value);
      }

      if (value.label !== undefined) {
        return String(value.label);
      }

      return '';
    }

    return (
      value !== undefined &&
      value !== null
        ? String(value)
        : ''
    );
  }

  function isVariantAvailable(variant) {
    return (
      !!variant &&
      variant.available !== false
    );
  }

  function getUniqueOptionValues(
    product,
    index
  ) {
    var variants =
      getProductVariants(product);

    var values = [];

    variants.forEach(function (variant) {
      var value =
        getVariantOptionValue(
          variant,
          index
        );

      if (
        value &&
        values.indexOf(value) === -1
      ) {
        values.push(value);
      }
    });

    return values;
  }

  function variantMatchesSelections(
    variant,
    selections,
    ignoreIndex
  ) {
    if (!variant) {
      return false;
    }

    for (
      var i = 0;
      i < selections.length;
      i++
    ) {
      if (i === ignoreIndex) {
        continue;
      }

      if (
        selections[i] &&
        getVariantOptionValue(
          variant,
          i
        ) !== selections[i]
      ) {
        return false;
      }
    }

    return true;
  }

  function getContextOptionValues(
    product,
    index,
    selections
  ) {
    var variants =
      getProductVariants(product);

    var values = [];

    variants.forEach(function (variant) {
      if (
        !variantMatchesSelections(
          variant,
          selections,
          index
        )
      ) {
        return;
      }

      var value =
        getVariantOptionValue(
          variant,
          index
        );

      if (
        value &&
        values.indexOf(value) === -1
      ) {
        values.push(value);
      }
    });

    return values;
  }

  function getAvailableOptionValue(
    product,
    index,
    value,
    selections
  ) {
    var variants =
      getProductVariants(product);

    return variants.some(function (variant) {
      if (
        getVariantOptionValue(
          variant,
          index
        ) !== value
      ) {
        return false;
      }

      if (
        !variantMatchesSelections(
          variant,
          selections,
          index
        )
      ) {
        return false;
      }

      return isVariantAvailable(
        variant
      );
    });
  }

  function findVariant(
    product,
    selections
  ) {
    var variants =
      getProductVariants(product);

    return (
      variants.find(function (variant) {
        for (
          var i = 0;
          i < selections.length;
          i++
        ) {
          if (
            getVariantOptionValue(
              variant,
              i
            ) !== selections[i]
          ) {
            return false;
          }
        }

        return true;
      }) || null
    );
  }

  function findVariantById(
    product,
    variantId
  ) {
    if (!variantId) {
      return null;
    }

    var variants =
      getProductVariants(product);

    return (
      variants.find(function (variant) {
        return (
          String(variant.id) ===
          String(variantId)
        );
      }) || null
    );
  }

  function getFirstAvailableVariant(product) {
    var variants =
      getProductVariants(product);

    return (
      variants.find(function (variant) {
        return isVariantAvailable(
          variant
        );
      }) ||
      variants[0] ||
      null
    );
  }

  function reconcileSelections(
    product,
    selections
  ) {
    var optionNames =
      getProductOptionNames(product);

    if (!optionNames.length) {
      return [];
    }

    var next =
      Array.isArray(selections)
        ? selections.slice()
        : [];

    while (
      next.length <
      optionNames.length
    ) {
      next.push('');
    }

    for (
      var pass = 0;
      pass < optionNames.length + 1;
      pass++
    ) {
      for (
        var i = 0;
        i < optionNames.length;
        i++
      ) {
        var values =
          getContextOptionValues(
            product,
            i,
            next
          );

        if (!values.length) {
          continue;
        }

        if (
          values.indexOf(
            next[i]
          ) === -1
        ) {
          next[i] =
            values[0];
        }
      }
    }

    return next;
  }

  function getInitialSelections(product) {
    var optionNames =
      getProductOptionNames(product);

    if (!optionNames.length) {
      return [];
    }

    var variants =
      getProductVariants(product);

    if (!variants.length) {
      return [];
    }

    if (
      Array.isArray(
        product.compareSelections
      ) &&
      product.compareSelections.length ===
        optionNames.length
    ) {
      return reconcileSelections(
        product,
        product.compareSelections
      );
    }

    var selectedVariant =
      findVariantById(
        product,
        product.compareVariantId
      );

    if (!selectedVariant) {
      selectedVariant =
        getFirstAvailableVariant(
          product
        );
    }

    if (!selectedVariant) {
      return [];
    }

    var selections = [];

    for (
      var i = 0;
      i < optionNames.length;
      i++
    ) {
      selections.push(
        getVariantOptionValue(
          selectedVariant,
          i
        )
      );
    }

    return reconcileSelections(
      product,
      selections
    );
  }

  /* --------------------------------------------------------------------------
     VARIANT IMAGE
     -------------------------------------------------------------------------- */

  function getVariantImage(
    product,
    variant
  ) {
    if (variant) {

      if (variant.featured_image) {

        if (
          typeof variant.featured_image ===
          'string'
        ) {
          return variant.featured_image;
        }

        if (
          variant.featured_image.src
        ) {
          return variant.featured_image.src;
        }
      }

      if (
        variant.featured_media &&
        variant.featured_media.preview_image &&
        variant.featured_media.preview_image.src
      ) {
        return (
          variant.featured_media
            .preview_image
            .src
        );
      }

      if (
        variant.image
      ) {
        if (
          typeof variant.image === 'string'
        ) {
          return variant.image;
        }

        if (
          variant.image.src
        ) {
          return variant.image.src;
        }
      }
    }

    var data =
      getShopifyProduct(product);

    if (
      data &&
      data.featured_image
    ) {
      if (
        typeof data.featured_image ===
        'string'
      ) {
        return data.featured_image;
      }

      if (
        data.featured_image.src
      ) {
        return data.featured_image.src;
      }
    }

    return product.image || '';
  }

  function getOptionDisplayName(name) {
    if (!name) {
      return '';
    }

    var cleanName =
      String(name).trim();

    if (
      cleanName.toLowerCase() ===
      'color'
    ) {
      return 'Colour';
    }

    return cleanName;
  }

  /* ==========================================================================
     PRODUCT PRICE
     ========================================================================== */

  function getVariantPriceHtml(
    product,
    variant
  ) {
    if (
      variant &&
      variant.price !== undefined
    ) {
      return (
        '<span class="trek-compare-product__price-value">' +
          escapeHtml(
            formatMoney(
              variant.price
            )
          ) +
        '</span>'
      );
    }

    var price =
      getPrice(product);

    if (!price) {
      return '';
    }

    return (
      '<span class="trek-compare-product__price-value">' +
        escapeHtml(price) +
      '</span>'
    );
  }

  /* ==========================================================================
     VARIANT CONTROLS HTML
     ========================================================================== */

  function renderVariantControls(product) {
    var optionNames =
      getProductOptionNames(product);

    var variants =
      getProductVariants(product);

    if (!variants.length) {
      return '';
    }

    var selections =
      getInitialSelections(product);

    product.compareSelections =
      selections;

    var selectedVariant =
      findVariant(
        product,
        selections
      );

    if (selectedVariant) {
      product.compareVariantId =
        selectedVariant.id;
    }

    var html =
      '<div class="trek-compare-product__purchase">' +

        '<button ' +
          'type="button" ' +
          'class="trek-compare-product__options-toggle' +
            (
              compareOptionsOpen
                ? ' is-open'
                : ''
            ) +
          '" ' +
          'data-compare-options-toggle ' +
          'aria-expanded="' +
            (
              compareOptionsOpen
                ? 'true'
                : 'false'
            ) +
          '"' +
        '>' +

          '<span ' +
            'class="trek-compare-product__options-toggle-label"' +
          '>' +
            'Select options' +
          '</span>' +

          '<span ' +
            'class="trek-compare-product__options-toggle-icon" ' +
            'aria-hidden="true"' +
          '>' +
            '+' +
          '</span>' +

        '</button>' +

        '<div ' +
          'class="trek-compare-product__options' +
            (
              compareOptionsOpen
                ? ' is-open'
                : ''
            ) +
          '" ' +
          (
            compareOptionsOpen
              ? ''
              : 'hidden'
          ) +
        '>';

    optionNames.forEach(function (
      optionName,
      index
    ) {
      var displayName =
        getOptionDisplayName(
          optionName
        );

      var values =
        getContextOptionValues(
          product,
          index,
          selections
        );

      html +=
        '<div ' +
          'class="trek-compare-product__option-group"' +
        '>' +

          '<label ' +
            'class="trek-compare-product__option-label" ' +
            'for="trek-compare-' +
              escapeHtml(product.id) +
              '-option-' +
              index +
            '"' +
          '>' +
            escapeHtml(
              displayName
            ) +
          '</label>' +

          '<select ' +
            'class="trek-compare-product__option-select" ' +
            'id="trek-compare-' +
              escapeHtml(product.id) +
              '-option-' +
              index +
            '" ' +
            'data-compare-option-select ' +
            'data-option-index="' +
              index +
            '" ' +
            'aria-label="' +
              escapeHtml(
                displayName
              ) +
            '"' +
          '>';

      values.forEach(function (value) {
        var available =
          getAvailableOptionValue(
            product,
            index,
            value,
            selections
          );

        html +=
          '<option ' +
            'value="' +
              escapeHtml(value) +
            '"' +
            (
              value ===
              selections[index]
                ? ' selected'
                : ''
            ) +
            (
              !available
                ? ' disabled'
                : ''
            ) +
          '>' +
            escapeHtml(value) +
          '</option>';
      });

      html +=
          '</select>' +
        '</div>';
    });

    html +=

          '<button ' +
            'type="button" ' +
            'class="trek-compare-product__add" ' +
            'data-compare-add-to-cart' +
          '>' +
            'Add to Cart' +
          '</button>' +

          '<div ' +
            'class="trek-compare-product__add-error" ' +
            'data-compare-add-error ' +
            'aria-live="polite"' +
          '></div>' +

        '</div>' +

      '</div>';

    return html;
  }

  /* ==========================================================================
     RENDER BAR
     ========================================================================== */

  function renderBar() {
    selectedProductsContainer.innerHTML = '';

    var compareCount =
      root.querySelector(
        '.trek-compare-count'
      );

    if (compareCount) {
      compareCount.textContent =
        products.length;
    }

    products.forEach(function (product) {
      var item =
        document.createElement('div');

      item.className =
        'trek-compare-selected-product';

      item.setAttribute(
        'data-product-id',
        product.id
      );

      var image =
        product.image || '';

item.innerHTML =
  (
    image
      ? '<img class="trek-compare-selected-product__image" src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(product.title) +
        '">'
      : '<div class="trek-compare-selected-product__image"></div>'
  ) +

  '<span class="trek-compare-selected-product__title">' +
    escapeHtml(product.title || 'Product') +
  '</span>' +

  '<button ' +
          'type="button" ' +
          'class="trek-compare-selected-product__remove" ' +
          'data-remove-product="' +
            escapeHtml(product.id) +
          '" ' +
          'aria-label="Remove ' +
            escapeHtml(product.title) +
          '"' +
        '>' +

          '<svg ' +
            'viewBox="0 0 24 24" ' +
            'fill="none" ' +
            'aria-hidden="true"' +
          '>' +

            '<path ' +
              'd="M6 6L18 18" ' +
              'stroke="currentColor" ' +
              'stroke-width="3" ' +
              'stroke-linecap="round"' +
            '/>' +

            '<path ' +
              'd="M18 6L6 18" ' +
              'stroke="currentColor" ' +
              'stroke-width="3" ' +
              'stroke-linecap="round"' +
            '/>' +

          '</svg>' +

        '</button>';

      selectedProductsContainer.appendChild(
        item
      );

      var thumbnail =
        item.querySelector('img');

      if (thumbnail) {
        thumbnail.addEventListener(
          'load',
          updateCompareScrollArrows
        );
      }
    });

    if (openButton) {
      openButton.disabled =
        products.length < 2;
    }

    if (products.length) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    updateCompareScrollArrows();
  }

  /* ==========================================================================
     COMPARISON ROW
     ========================================================================== */

  function createComparisonRow(
    labelText,
    values,
    htmlValues
  ) {
    var row =
      document.createElement('div');

    row.className =
      'trek-compare-row';

    var label =
      document.createElement('div');

    label.className =
      'trek-compare-field trek-compare-field--name';

    label.textContent =
      labelText;

    row.appendChild(label);

    values.forEach(function (value, index) {
      var cell =
        document.createElement('div');

      cell.className =
        'trek-compare-value';

      var content =
        htmlValues
          ? htmlValues[index]
          : escapeHtml(value);

      if (hasValue(value)) {
        cell.innerHTML =
          content;
      } else {
        cell.innerHTML =
          '';
      }

      row.appendChild(cell);
    });

    return row;
  }

  /* ==========================================================================
     STICKY ROW OFFSETS
     ========================================================================== */

  function updateCompareStickyOffsets() {

    var productFixedRow =
      table.querySelector(
        '.trek-compare-row--product-fixed'
      );

    var priceFixedRow =
      table.querySelector(
        '.trek-compare-row--price-fixed'
      );

    if (!priceFixedRow) {
      return;
    }

    if (productFixedRow) {
      priceFixedRow.style.top =
        (productFixedRow.offsetHeight - 1) + 'px';
    } else {
      priceFixedRow.style.top =
        '0px';
    }
  }

  /* ==========================================================================
     PRODUCT HEADER
     
     STRUCTURE:
     
     ROW 1 = sticky Product
     ROW 2 = sticky Price
     ROW 3 = normal scrolling Shop + options
     ========================================================================== */

  function renderProductHeader() {

    if (!shouldShowField('product')) {
      return;
    }

    /* ------------------------------------------------------------------------
       STICKY PRODUCT ROW
       ------------------------------------------------------------------------ */

    var fixedRow =
      document.createElement('div');

    fixedRow.className =
      'trek-compare-row trek-compare-row--product-fixed';

    var fixedField =
      document.createElement('div');

    fixedField.className =
      'trek-compare-field trek-compare-field--name';

    fixedField.textContent =
      getFieldName(
        'product',
        'Product'
      );

    fixedRow.appendChild(
      fixedField
    );

    products.forEach(function (product) {

      var fixedCell =
        document.createElement('div');

      fixedCell.className =
        'trek-compare-product trek-compare-product--fixed';

      fixedCell.setAttribute(
        'data-compare-fixed-product-id',
        product.id
      );

      var image =
        product.image || '';

      fixedCell.innerHTML =

        '<div class="trek-compare-product__image-wrap">' +

          (
            image
              ? '<img class="trek-compare-product__image" src="' +
                  escapeHtml(image) +
                  '" alt="' +
                  escapeHtml(product.title) +
                '">'
              : ''
          ) +

          '<button ' +
            'type="button" ' +
            'class="trek-compare-product__remove" ' +
            'data-remove-product="' +
              escapeHtml(product.id) +
            '" ' +
            'aria-label="Remove ' +
              escapeHtml(product.title) +
            '"' +
          '>' +

            '<svg ' +
              'viewBox="0 0 24 24" ' +
              'fill="none" ' +
              'aria-hidden="true"' +
            '>' +

              '<path ' +
                'd="M6 6L18 18" ' +
                'stroke="currentColor" ' +
                'stroke-width="3" ' +
                'stroke-linecap="round"' +
              '/>' +

              '<path ' +
                'd="M18 6L6 18" ' +
                'stroke="currentColor" ' +
                'stroke-width="3" ' +
                'stroke-linecap="round"' +
              '/>' +

            '</svg>' +

          '</button>' +

        '</div>' +

        '<a ' +
          'class="trek-compare-product__title" ' +
          'href="' +
            escapeHtml(
              product.url || '#'
            ) +
          '"' +
        '>' +
          escapeHtml(
            product.title ||
            'Product'
          ) +
        '</a>';

      fixedRow.appendChild(
        fixedCell
      );
    });

    table.appendChild(
      fixedRow
    );
  }

  /* ==========================================================================
     PRICE
     
     Price is its OWN sticky row.
     It is inserted directly after Product.
     ========================================================================== */

  function renderPrice() {

    if (!shouldShowField('price')) {
      return;
    }

    var priceRow =
      document.createElement('div');

    priceRow.className =
      'trek-compare-row trek-compare-row--price-fixed';

    var priceField =
      document.createElement('div');

    priceField.className =
      'trek-compare-field trek-compare-field--name';

    priceField.textContent =
      getFieldName(
        'price',
        'Price'
      );

    priceRow.appendChild(
      priceField
    );

    products.forEach(function (product) {

      var priceCell =
        document.createElement('div');

      priceCell.className =
        'trek-compare-product trek-compare-product--price-fixed';

      priceCell.setAttribute(
        'data-compare-price-fixed-product-id',
        product.id
      );

      var selections =
        getInitialSelections(
          product
        );

      var variant =
        findVariant(
          product,
          selections
        );

      priceCell.innerHTML =
        '<div ' +
          'class="trek-compare-product__price" ' +
          'data-compare-product-price' +
        '>' +
          getVariantPriceHtml(
            product,
            variant
          ) +
        '</div>';

      priceRow.appendChild(
        priceCell
      );
    });

    table.appendChild(
      priceRow
    );
  }

  /* ==========================================================================
     NORMAL SCROLLING PRODUCT INFO ROW
     
     ROW 3:
     - Select Options
     - Variant selectors
     - Add to Cart
     
     This row is NOT sticky.
     ========================================================================== */

  function renderProductInfoHeader() {

    var headerRow =
      document.createElement('div');

    headerRow.className =
      'trek-compare-row trek-compare-row--header';

    var headerField =
      document.createElement('div');

    headerField.className =
      'trek-compare-field trek-compare-field--name trek-compare-field--header-empty';

    headerField.textContent =
      'Shop';

    headerField.setAttribute(
      'aria-hidden',
      'true'
    );

    headerRow.appendChild(
      headerField
    );

    products.forEach(function (product) {

      var productCell =
        document.createElement('div');

      productCell.className =
        'trek-compare-product trek-compare-product--header';

      productCell.setAttribute(
        'data-compare-product-id',
        product.id
      );

      productCell.innerHTML =
        renderVariantControls(
          product
        );

      headerRow.appendChild(
        productCell
      );
    });

    table.appendChild(
      headerRow
    );
  }

  /* ==========================================================================
     PDP TAGLINE
     ========================================================================== */

  function renderPdpTagline() {
    if (!shouldShowField('pdp_tagline')) {
      return;
    }

    var values =
      products.map(function (product) {
        return getPdpTagline(product);
      });

    if (!values.some(hasValue)) {
      return;
    }

    var htmlValues =
      values.map(function (value) {
        return formatTagline(value);
      });

    table.appendChild(
      createComparisonRow(
        getFieldName(
          'pdp_tagline',
          'PDP Tagline'
        ),
        values,
        htmlValues
      )
    );
  }

  /* ==========================================================================
     DESCRIPTION
     ========================================================================== */

  function renderDescription() {
    if (!shouldShowField('description')) {
      return;
    }

    var values =
      products.map(function (product) {
        return getDescription(product);
      });

    if (!values.some(hasValue)) {
      return;
    }

    var htmlValues =
      values.map(function (value) {
        return formatDescription(value);
      });

    table.appendChild(
      createComparisonRow(
        getFieldName(
          'description',
          'Description'
        ),
        values,
        htmlValues
      )
    );
  }

  /* ==========================================================================
     JSON SPECIFICATIONS
     ========================================================================== */

  function renderSpecifications() {
    if (!shouldShowField('specifications')) {
      return;
    }

    var specifications =
      products.map(function (product) {
        return getTableTest2(product);
      });

    if (!specifications.some(hasValue)) {
      return;
    }

    var keys = [];

    specifications.forEach(function (specification) {
      if (
        !specification ||
        typeof specification !== 'object'
      ) {
        return;
      }

      if (Array.isArray(specification)) {
        specification.forEach(function (item) {
          if (
            item &&
            typeof item === 'object'
          ) {
            Object.keys(item).forEach(function (key) {
              if (
                keys.indexOf(key) === -1
              ) {
                keys.push(key);
              }
            });
          }
        });
      } else {
        Object.keys(specification).forEach(function (key) {
          if (
            keys.indexOf(key) === -1
          ) {
            keys.push(key);
          }
        });
      }
    });

    keys.forEach(function (key) {
      var values =
        specifications.map(function (specification) {
          return getJsonKeyValue(
            specification,
            key
          );
        });

      if (!values.some(hasValue)) {
        return;
      }

      var htmlValues =
        values.map(function (value) {
          return formatGenericValue(value);
        });

      table.appendChild(
        createComparisonRow(
          formatLabel(key),
          values,
          htmlValues
        )
      );
    });
  }

  /* ==========================================================================
     JSON KEY VALUE
     ========================================================================== */

  function getJsonKeyValue(
    specification,
    key
  ) {
    if (!specification) {
      return '';
    }

    if (Array.isArray(specification)) {
      var results = [];

      specification.forEach(function (item) {
        if (
          item &&
          typeof item === 'object' &&
          hasValue(item[key])
        ) {
          results.push(
            item[key]
          );
        }
      });

      if (results.length === 1) {
        return results[0];
      }

      if (results.length > 1) {
        return results;
      }

      return '';
    }

    if (
      typeof specification ===
      'object'
    ) {
      return specification[key];
    }

    return '';
  }

  /* ==========================================================================
     TECHNOLOGIES
     ========================================================================== */

  function renderTechnologies() {
    if (!shouldShowField('technology')) {
      return;
    }

    var technologies =
      products.map(function (product) {
        return getTechnologies(product);
      });

    if (
      !technologies.some(function (items) {
        return (
          Array.isArray(items) &&
          items.length > 0
        );
      })
    ) {
      return;
    }

    var htmlValues =
      technologies.map(function (items) {
        return formatTechnologies(items);
      });

    var values =
      technologies.map(function (items) {
        return (
          Array.isArray(items) &&
          items.length
        )
          ? 'technology'
          : '';
      });

    table.appendChild(
      createComparisonRow(
        getFieldName(
          'technology',
          'Technology'
        ),
        values,
        htmlValues
      )
    );
  }

  /* ==========================================================================
     RENDER CONFIGURED FIELDS
     
     IMPORTANT:
     
     Product, Price and Shop are deliberately rendered first,
     regardless of their position in the stored config.
     
     This guarantees:
     
     Product
     Price
     Shop
     Other comparison rows
     
     ========================================================================== */

  function renderConfiguredFields() {

    var config =
      getCompareConfig();

    /* ------------------------------------------------------------------------
       FIXED / PURCHASE AREA
       ------------------------------------------------------------------------ */

    if (shouldShowField('product')) {
      renderProductHeader();
    }

    if (shouldShowField('price')) {
      renderPrice();
    }

    if (shouldShowField('product')) {
      renderProductInfoHeader();
    }

    /* ------------------------------------------------------------------------
       NORMAL COMPARISON ROWS
       ------------------------------------------------------------------------ */

    config.forEach(function (field) {

      if (
        !field ||
        field.show === false
      ) {
        return;
      }

      switch (field.type) {

        case 'product':
        case 'price':
          /*
           * Already rendered above in the fixed section.
           */
          break;

        case 'pdp_tagline':
          renderPdpTagline();
          break;

        case 'description':
          renderDescription();
          break;

        case 'specifications':
          renderSpecifications();
          break;

        case 'technology':
          renderTechnologies();
          break;
      }
    });
  }

  /* ==========================================================================
     UPDATE PRODUCT VARIANT UI
     ========================================================================== */

  function updateProductVariantUI(
    product,
    productCell
  ) {
    if (
      !product ||
      !productCell
    ) {
      return;
    }

    var variants =
      getProductVariants(product);

    var optionNames =
      getProductOptionNames(product);

    if (
      !variants.length ||
      !optionNames.length
    ) {
      return;
    }

    var selects =
      Array.prototype.slice.call(
        productCell.querySelectorAll(
          '[data-compare-option-select]'
        )
      );

    var selections =
      selects.map(function (select) {
        return select.value;
      });

    selections =
      reconcileSelections(
        product,
        selections
      );

    product.compareSelections =
      selections;

    /* ------------------------------------------------------------------------
       REBUILD DROPDOWNS
       ------------------------------------------------------------------------ */

    selects.forEach(function (select) {

      var index =
        Number(
          select.getAttribute(
            'data-option-index'
          )
        );

      var currentValue =
        selections[index];

      var values =
        getContextOptionValues(
          product,
          index,
          selections
        );

      select.innerHTML =
        '';

      values.forEach(function (value) {

        var option =
          document.createElement(
            'option'
          );

        var available =
          getAvailableOptionValue(
            product,
            index,
            value,
            selections
          );

        option.value =
          value;

        option.textContent =
          value;

        option.disabled =
          !available;

        if (
          value ===
          currentValue
        ) {
          option.selected =
            true;
        }

        select.appendChild(
          option
        );
      });

      if (
        values.indexOf(
          currentValue
        ) !== -1
      ) {
        select.value =
          currentValue;
      }
    });

    /* ------------------------------------------------------------------------
       FIND SELECTED VARIANT
       ------------------------------------------------------------------------ */

    var variant =
      findVariant(
        product,
        selections
      );

    if (!variant) {

      variant =
        getFirstAvailableVariant(
          product
        );

      if (variant) {

        selections =
          optionNames.map(function (
            optionName,
            index
          ) {
            return getVariantOptionValue(
              variant,
              index
            );
          });

        product.compareSelections =
          selections;

        selects.forEach(function (select) {

          var index =
            Number(
              select.getAttribute(
                'data-option-index'
              )
            );

          select.value =
            selections[index];
        });
      }
    }

    if (variant) {
      product.compareVariantId =
        variant.id;
    } else {
      product.compareVariantId =
        null;
    }

    /* ------------------------------------------------------------------------
       UPDATE STICKY PRODUCT IMAGE
       ------------------------------------------------------------------------ */

    var imageUrl =
      getVariantImage(
        product,
        variant
      );

    if (imageUrl) {

      var fixedCells =
        table.querySelectorAll(
          '[data-compare-fixed-product-id]'
        );

      var fixedCell =
        null;

      for (
        var fixedIndex = 0;
        fixedIndex < fixedCells.length;
        fixedIndex++
      ) {

        if (
          String(
            fixedCells[fixedIndex].getAttribute(
              'data-compare-fixed-product-id'
            )
          ) ===
          String(product.id)
        ) {

          fixedCell =
            fixedCells[fixedIndex];

          break;
        }
      }

      if (fixedCell) {

        var fixedImage =
          fixedCell.querySelector(
            '.trek-compare-product__image'
          );

        if (fixedImage) {
          fixedImage.src =
            imageUrl;
        }
      }
    }

    /* ------------------------------------------------------------------------
       UPDATE STICKY PRICE ROW
       ------------------------------------------------------------------------ */

    var fixedPriceCells =
      table.querySelectorAll(
        '[data-compare-price-fixed-product-id]'
      );

    var fixedPriceCell =
      null;

    for (
      var fixedPriceIndex = 0;
      fixedPriceIndex < fixedPriceCells.length;
      fixedPriceIndex++
    ) {

      if (
        String(
          fixedPriceCells[fixedPriceIndex].getAttribute(
            'data-compare-price-fixed-product-id'
          )
        ) ===
        String(product.id)
      ) {

        fixedPriceCell =
          fixedPriceCells[fixedPriceIndex];

        break;
      }
    }

    if (fixedPriceCell) {

      var priceElement =
        fixedPriceCell.querySelector(
          '[data-compare-product-price]'
        );

      if (priceElement) {

        priceElement.innerHTML =
          getVariantPriceHtml(
            product,
            variant
          );
      }
    }

    /* ------------------------------------------------------------------------
       CLEAR / UPDATE STICKY OFFSET
       ------------------------------------------------------------------------ */

    updateCompareStickyOffsets();

    /* ------------------------------------------------------------------------
       UPDATE ADD TO CART
       ------------------------------------------------------------------------ */

    var addButton =
      productCell.querySelector(
        '[data-compare-add-to-cart]'
      );

    if (addButton) {

      var available =
        !!variant &&
        isVariantAvailable(
          variant
        );

      addButton.disabled =
        !available;

      addButton.setAttribute(
        'data-variant-id',
        variant
          ? variant.id
          : ''
      );

      if (available) {

        addButton.textContent =
          'Add to Cart';

      } else if (variant) {

        addButton.textContent =
          'Sold out';

      } else {

        addButton.textContent =
          'Unavailable';
      }
    }

    /* ------------------------------------------------------------------------
       CLEAR PREVIOUS ERROR
       ------------------------------------------------------------------------ */

    var error =
      productCell.querySelector(
        '[data-compare-add-error]'
      );

    if (error) {

      error.textContent =
        '';

      error.classList.remove(
        'is-visible'
      );
    }
  }

  function initialiseVariantControls() {

    var cells =
      table.querySelectorAll(
        '[data-compare-product-id]'
      );

    cells.forEach(function (productCell) {

      var productId =
        productCell.getAttribute(
          'data-compare-product-id'
        );

      var product =
        getProductById(
          productId
        );

      if (!product) {
        return;
      }

      updateProductVariantUI(
        product,
        productCell
      );
    });
  }

  /* ==========================================================================
     GLOBAL OPTIONS OPEN / CLOSE
     ========================================================================== */

  function setAllOptionsExpanded(open) {

    compareOptionsOpen =
      !!open;

    var cells =
      table.querySelectorAll(
        '[data-compare-product-id]'
      );

    cells.forEach(function (productCell) {

      productCell.classList.toggle(
        'is-options-open',
        compareOptionsOpen
      );

      var toggle =
        productCell.querySelector(
          '[data-compare-options-toggle]'
        );

      var options =
        productCell.querySelector(
          '.trek-compare-product__options'
        );

      if (toggle) {

        toggle.classList.toggle(
          'is-open',
          compareOptionsOpen
        );

        toggle.setAttribute(
          'aria-expanded',
          compareOptionsOpen
            ? 'true'
            : 'false'
        );
      }

      if (options) {

        options.classList.toggle(
          'is-open',
          compareOptionsOpen
        );

        options.hidden =
          !compareOptionsOpen;
      }
    });
  }

  /* ==========================================================================
     CLOSE OPTIONS WHEN USER STARTS SCROLLING UP
     ========================================================================== */

  var compareTouchStartY = null;

  /* --------------------------------------------------------------------------
     MOUSE / TRACKPAD
     -------------------------------------------------------------------------- */

  document.addEventListener(
    'wheel',
    function (event) {
      if (
        !drawer.classList.contains('is-open') ||
        !compareOptionsOpen
      ) {
        return;
      }

      if (event.deltaY > 0) {
        setAllOptionsExpanded(false);
      }
    },
    { passive: true }
  );

  /* --------------------------------------------------------------------------
     TOUCH / MOBILE
     -------------------------------------------------------------------------- */

  document.addEventListener(
    'touchstart',
    function (event) {
      if (
        !drawer.classList.contains('is-open') ||
        !compareOptionsOpen
      ) {
        return;
      }

      if (
        event.touches &&
        event.touches.length
      ) {
        compareTouchStartY =
          event.touches[0].clientY;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (
        !drawer.classList.contains('is-open') ||
        !compareOptionsOpen ||
        compareTouchStartY === null
      ) {
        return;
      }

      if (
        !event.touches ||
        !event.touches.length
      ) {
        return;
      }

      var currentY =
        event.touches[0].clientY;

      if (
        currentY <
        compareTouchStartY
      ) {
        setAllOptionsExpanded(false);

        compareTouchStartY = null;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      compareTouchStartY = null;
    },
    { passive: true }
  );

  /* ==========================================================================
     RENDER TABLE
     ========================================================================== */

  function renderTable() {

    table.innerHTML =
      '';

    if (!products.length) {

      table.style.display =
        'none';

      emptyState.classList.add(
        'is-visible'
      );

      return;
    }

    table.style.display =
      'block';

    emptyState.classList.remove(
      'is-visible'
    );

    renderConfiguredFields();

    initialiseVariantControls();

    updateCompareStickyOffsets();

    /* ------------------------------------------------------------------------
       RECALCULATE AFTER PRODUCT IMAGES LOAD
       ------------------------------------------------------------------------ */

    var stickyImages =
      table.querySelectorAll(
        '.trek-compare-row--product-fixed .trek-compare-product__image'
      );

    stickyImages.forEach(function (image) {

      if (!image.complete) {

        image.addEventListener(
          'load',
          updateCompareStickyOffsets,
          { once: true }
        );

      }

    });

    setAllOptionsExpanded(
      compareOptionsOpen
    );
  }

  /* ==========================================================================
     STICKY OFFSET RESIZE
     ========================================================================== */

  window.addEventListener(
    'resize',
    debounce(
      150,
      updateCompareStickyOffsets
    )
  );

  /* ==========================================================================
     OPEN DRAWER
     ========================================================================== */

  function openDrawer() {

    if (!products.length) {
      return;
    }

    if (!compareHistoryActive) {

      window.history.pushState(
        {
          trekCompareDrawer: true
        },
        '',
        window.location.href
      );

      compareHistoryActive =
        true;
    }

    drawer.classList.add(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'trek-compare-open'
    );

    renderTable();

    /*
     * Every product already carries its variant data (cached in
     * localStorage from a previous open), so there is nothing to fetch and
     * no reason to tear the table down and rebuild it.
     */

    var needsFetch =
      products.some(function (product) {
        return !getShopifyProduct(product);
      });

    if (!needsFetch) {
      return;
    }

    Promise.all(
      products.map(function (product) {
        return fetchProductData(
          product
        );
      })
    ).then(function () {

      if (!drawer.classList.contains('is-open')) {
        saveProducts();
        return;
      }

      saveProducts();

      renderTable();

    });
  }

  /* ==========================================================================
     CLOSE DRAWER
     ========================================================================== */

  function closeDrawer(
    fromHistory
  ) {

    drawer.classList.remove(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'trek-compare-open'
    );

    compareOptionsOpen =
      false;

    if (compareHistoryActive) {

      compareHistoryActive =
        false;

      if (!fromHistory) {
        window.history.back();
      }
    }
  }

  /* ==========================================================================
     ADD PRODUCT
     ========================================================================== */

  function addProduct(product) {

    if (
      !product ||
      !product.id
    ) {
      return;
    }

    if (
      productExists(
        product.id
      )
    ) {
      return;
    }

    var pageData =
      getPageProductData(
        product.handle
      );

    if (pageData) {

      product.id =
        pageData.id ||
        product.id;

      product.url =
        pageData.url ||
        product.url;

      product.title =
        pageData.title ||
        product.title;

      product.image =
        pageData.image ||
        product.image;

      product.vendor =
        pageData.vendor ||
        product.vendor;

      product.metafields =
        pageData;

      product.data =
        pageData;

      if (
        Array.isArray(
          pageData.variants
        )
      ) {
        product.shopifyProduct =
          pageData;
      }

      product.dataLoaded =
        true;
    }

    products.push(
      product
    );

    saveProducts();

    setBarExpanded(true);

    renderBar();

    syncCheckboxes();
  }

  /* ==========================================================================
     REMOVE PRODUCT
     ========================================================================== */

  function removeProduct(
    productId
  ) {

    products =
      products.filter(function (product) {
        return (
          String(product.id) !==
          String(productId)
        );
      });

    saveProducts();

    renderBar();

    syncCheckboxes();

    if (
      drawer.classList.contains(
        'is-open'
      )
    ) {
      renderTable();
    }

    if (!products.length) {
      closeDrawer();
    }
  }

  /* ==========================================================================
     CLEAR ALL
     ========================================================================== */

  function clearProducts() {

    products = [];

    compareOptionsOpen =
      false;

    saveProducts();

    renderBar();

    syncCheckboxes();

    closeDrawer();
  }

  /* ==========================================================================
     SYNC CHECKBOXES
     ========================================================================== */

  function syncCheckboxes() {

    var checkboxes =
      document.querySelectorAll(
        '.trek-compare-checkbox'
      );

    checkboxes.forEach(function (checkbox) {

      checkbox.checked =
        productExists(
          checkbox.getAttribute(
            'data-product-id'
          )
        );
    });
  }

  /* ==========================================================================
     CHECKBOX INITIALISATION
     ========================================================================== */

  function initialiseCheckboxes() {

    var checkboxes =
      document.querySelectorAll(
        '.trek-compare-checkbox'
      );

    checkboxes.forEach(function (checkbox) {

      if (
        checkbox.dataset
          .compareInitialised ===
        'true'
      ) {

        checkbox.checked =
          productExists(
            checkbox.getAttribute(
              'data-product-id'
            )
          );

        return;
      }

      checkbox.dataset
        .compareInitialised =
        'true';

      checkbox.checked =
        productExists(
          checkbox.getAttribute(
            'data-product-id'
          )
        );

      checkbox.addEventListener(
        'change',
        function () {

          var product =
            getProductFromCheckbox(
              checkbox
            );

          if (!product) {
            return;
          }

          if (
            checkbox.checked
          ) {

            addProduct(
              product
            );

          } else {

            removeProduct(
              product.id
            );
          }
        }
      );
    });
  }

  /* ==========================================================================
     TABLE CLICK EVENTS
     ========================================================================== */

  table.addEventListener(
    'click',
    function (event) {

      var toggle =
        event.target.closest(
          '[data-compare-options-toggle]'
        );

      if (toggle) {

        event.preventDefault();

        setAllOptionsExpanded(
          !compareOptionsOpen
        );

        return;
      }

      var addButton =
        event.target.closest(
          '[data-compare-add-to-cart]'
        );

      if (addButton) {

        event.preventDefault();

        if (addButton.disabled) {
          return;
        }

        var productCell =
          addButton.closest(
            '[data-compare-product-id]'
          );

        if (!productCell) {
          return;
        }

        var productId =
          productCell.getAttribute(
            'data-compare-product-id'
          );

        var product =
          getProductById(
            productId
          );

        if (!product) {
          return;
        }

        var variant =
          findVariant(
            product,
            product.compareSelections ||
              []
          );

        if (!variant) {
          return;
        }

        addVariantToCart(
          product,
          variant,
          addButton,
          productCell
        );

        return;
      }
    }
  );

  /* ==========================================================================
     TABLE CHANGE EVENTS
     ========================================================================== */

  table.addEventListener(
    'change',
    function (event) {

      var select =
        event.target.closest(
          '[data-compare-option-select]'
        );

      if (!select) {
        return;
      }

      var productCell =
        select.closest(
          '[data-compare-product-id]'
        );

      if (!productCell) {
        return;
      }

      var productId =
        productCell.getAttribute(
          'data-compare-product-id'
        );

      var product =
        getProductById(
          productId
        );

      if (!product) {
        return;
      }

      updateProductVariantUI(
        product,
        productCell
      );
    }
  );

  /* ==========================================================================
     REMOVE BUTTONS
     ========================================================================== */

  document.addEventListener(
    'click',
    function (event) {

      var removeButton =
        event.target.closest(
          '[data-remove-product]'
        );

      if (!removeButton) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      removeProduct(
        removeButton.getAttribute(
          'data-remove-product'
        )
      );
    },
    true
  );

  /* ==========================================================================
     IMPULSE 7.5.0 CART DRAWER
     ========================================================================== */

  function openImpulseCartDrawer(
    productResponse
  ) {

    try {

      document.dispatchEvent(
        new CustomEvent(
          'ajaxProduct:added',
          {
            detail: {
              product:
                productResponse
            }
          }
        )
      );

      return;

    } catch (error) {}

    try {

      document.dispatchEvent(
        new CustomEvent(
          'cart:build'
        )
      );

    } catch (error) {}

    try {

      document.dispatchEvent(
        new CustomEvent(
          'cart:open'
        )
      );

    } catch (error) {}
  }

  /* ==========================================================================
     ADD VARIANT TO CART
     ========================================================================== */

  function addVariantToCart(
    product,
    variant,
    button,
    productCell
  ) {

    if (
      !variant ||
      !variant.id ||
      !isVariantAvailable(
        variant
      )
    ) {
      return;
    }

    var errorElement =
      productCell.querySelector(
        '[data-compare-add-error]'
      );

    if (errorElement) {

      errorElement.textContent =
        '';

      errorElement.classList.remove(
        'is-visible'
      );
    }

    button.disabled =
      true;

    button.classList.add(
      'is-loading'
    );

    button.textContent =
      'Adding…';

    var rootPath =
      (
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
      )
        ? Shopify.routes.root
        : '/';

    var cartAddUrl =
      rootPath +
      'cart/add.js';

    fetch(
      cartAddUrl,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id:
                Number(
                  variant.id
                ),

              quantity: 1
            }
          ]
        })
      }
    )
      .then(function (response) {

        return response.json()
          .then(function (data) {

            if (!response.ok) {

              throw new Error(
                data.description ||
                data.message ||
                'Unable to add this product to the cart.'
              );
            }

            return data;
          });
      })
      .then(function (productResponse) {

        closeDrawer();

        setTimeout(function () {

          openImpulseCartDrawer(
            productResponse
          );

        }, 100);
      })
      .catch(function (error) {

        button.disabled =
          false;

        button.classList.remove(
          'is-loading'
        );

        button.textContent =
          'Add to Cart';

        if (errorElement) {

          errorElement.textContent =
            error.message ||
            'Unable to add this product to the cart.';

          errorElement.classList.add(
            'is-visible'
          );
        }
      });
  }

  /* ==========================================================================
     BAR EVENTS
     ========================================================================== */

  if (openButton) {

    openButton.addEventListener(
      'click',
      function () {
        openDrawer();
      }
    );
  }

  if (clearButton) {

    clearButton.addEventListener(
      'click',
      function () {
        clearProducts();
      }
    );
  }

  closeButtons.forEach(function (button) {

    button.addEventListener(
      'click',
      function () {
        closeDrawer();
      }
    );
  });

  /* ==========================================================================
     ESCAPE
     ========================================================================== */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        drawer.classList.contains(
          'is-open'
        )
      ) {
        closeDrawer();
      }
    }
  );

  /* ==========================================================================
     BROWSER BACK / MOBILE SWIPE
     ========================================================================== */

  window.addEventListener(
    'popstate',
    function () {

      if (
        compareHistoryActive &&
        drawer.classList.contains(
          'is-open'
        )
      ) {

        closeDrawer(true);
      }
    }
  );

  /* ==========================================================================
     RESTORE COMPARE STATE
     ========================================================================== */

  window.addEventListener(
    'pageshow',
    function (event) {

      if (event.persisted) {

        loadProducts();

        renderBar();

        syncCheckboxes();
      }
    }
  );

  /* ==========================================================================
     INITIALISE
     ========================================================================== */

  loadProducts();

  renderBar();

  initialiseCheckboxes();

  /* ==========================================================================
     DYNAMIC SHOPIFY PRODUCT GRIDS
     ========================================================================== */

  if (
    root.hasAttribute(
      'data-compare-observe'
    ) &&
    typeof MutationObserver !==
      'undefined'
  ) {

    var scheduleCheckboxInit =
      debounce(
        100,
        initialiseCheckboxes
      );

    /*
     * renderBar() and renderTable() mutate the DOM inside `root`, which would
     * otherwise re-trigger this observer on every bar/table update.
     */

    var observer =
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (!root.contains(mutations[i].target)) {
            scheduleCheckboxInit();
            return;
          }
        }
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

})();